module.exports = __webpack_public_path__ + "static/media/mehndi.c48a91c0.jpg";